<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     首页
  +---------------------------------------------------------------------------------------
-->

<template>
	<div class="sys-user header-padding">
		<f-page-header />

		<div class="filter-container">
			<div class="filter-box">
				<span class="filter-item sm">
					<el-select v-model="query.roleid" clearable placeholder="选择角色" @change="fetchData">
						<el-option v-for="item in roleList" :key="item.roleid" :label="item.desc" :value="item.roleid"> </el-option>
					</el-select>
				</span>

				<span class="filter-item sm">
					<f-search-input v-model="query.keyword" @change="fetchData" />
				</span>
			</div>

			<div class="toolbox">
				<el-button type="success" icon="el-icon-plus" @click="editorUser(-1)">新建成员</el-button>
				<el-button type="success" icon="el-icon-folder-add" plain @click="importShow = true">导入</el-button>
			</div>
		</div>

		<el-card v-loading="loading" class="table-card" shadow="never">
			<el-table ref="listTable" size="medium" class="padding-small" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="60" :selectable="selectfilter"></el-table-column>

				<el-table-column label="工号" min-width="100" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.worker_no }}</span>
					</template>
				</el-table-column>
				<el-table-column label="" width="50">
					<template slot-scope="scope">
						<f-user-avatar :user="scope.row"></f-user-avatar>
					</template>
				</el-table-column>
				<el-table-column label="姓名" min-width="160">
					<template slot-scope="scope">
						<f-user-name class="ml-sm" :user="scope.row"></f-user-name>
						<i v-if="scope.row.gender" class="el-icon-user-solid font-md ml-sm" :class="scope.row.gender == 1 ? 'text-blue' : 'text-danger'"></i>
					</template>
				</el-table-column>

				<el-table-column label="手机号" min-width="80">
					<template slot-scope="scope">
						<span>{{ scope.row.mobile }}</span>
					</template>
				</el-table-column>
				<el-table-column label="邮箱" min-width="120" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.email }}</span>
					</template>
				</el-table-column>
				<el-table-column label="权限" min-width="60">
					<template slot-scope="scope">
						<span>{{ scope.row.roleid != -1 ? scope.row.title : '管理员' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="最近活跃时间" min-width="100">
					<template slot-scope="scope">
						<span>{{ scope.row.lastvisit | parseTime }}</span>
					</template>
				</el-table-column>

				<el-table-column label="操作" width="160" align="right">
					<template slot-scope="scope">
						<el-button v-if="!scope.row.is_owner" type="text" @click="editorUser(scope.row.uid)">编辑</el-button>

						<el-popover v-if="!scope.row.is_owner" placement="left-start" width="120" trigger="click" popper-class="tool-pop" :visible-arrow="false">
							<div class="pop-item" role="button" @click="resetP(scope.row)">重置密码</div>
							<div class="pop-item" role="button" @click="DeleteU(scope.row)">删除</div>
							<i class="el-icon-more font-md ml-lg mr-sm" slot="reference" role="button"></i>
						</el-popover>
					</template>
				</el-table-column>

				<template slot="empty">
					<img class="image huger mt-lg" src="@/assets/empty.png" />
					<div class="font-md mb-hg">暂无数据</div>
				</template>
			</el-table>
		</el-card>

		<f-table-footer checkbox :list="list" :selection="multiSelection" @toggle="toggleAll" :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData">
			<template slot="left">
				<el-button plain :disabled="multiSelection.length === 0" size="mini" @click="DeleteU(0)">删除</el-button>
				<el-button class="ml-lg" plain size="mini" @click="exportUser">导出</el-button>
			</template>
		</f-table-footer>

		<user-editor v-if="showEditor" :show.sync="showEditor" :uid="uid" @change="fetchData"></user-editor>

		<sys-user-import v-if="importShow" :show.sync="importShow" @submit="fetchData" />
	</div>
</template>

<script>
import { getUserList, delUserApi, editUserApi, exportUserApi } from '@/api/sys/userApi'
import { getAllRole } from '@/api/sys/roleApi'
export default {
	name: 'SysUser',

	components: {
		UserEditor: () => import('./components/UserEditor'),
		SysUserImport: () => import('./components/SysUserImport')
	},

	data () {
		return {
			importShow: false,
			showEditor: false,
			query: {
				keyword: '',
				roleid: null,
				pindex: 1,
				psize: this.$store.state.commonStore.psize
			},
			showNew: true,
			uploadFile: false,
			total: 11,
			multiSelection: [],
			uid: -1,
			list: [],
			loading: false,
			uid: undefined,
			roleList: []
		}
	},
	computed: {},

	created () {
		this.fetchData()
		getAllRole().then(res => {
			if (!res.errno) {
				this.roleList = res.data.list
			} else {
				this.$message.error(res.message)
			}
		})
	},

	methods: {
		fetchData () {
			this.loading = true
			getUserList(this.query).then(res => {
				this.loading = false
				if (!res.errno) {
					this.list = res.data.list
					this.total = res.data.total
					this.query.pindex = res.data.pindex
					this.query.psize = res.data.psize
				} else {
					this.$message.error(res.message)
				}
			})
		},

		selectfilter (row, index) {
			if (row.is_owner) {
				return false
			} else {
				return true
			}
		},

		handleSelectionChange (val) {
			this.multiSelection = val
		},

		toggleAll () {
			this.$refs.listTable.toggleAllSelection()
		},

		exportUser () {
			exportUserApi(this.query).then(res => {
				if (!res.errno) {
					window.open(res.data.url)
					this.$message.success('用户导出成功！')
				}
			})
		},

		DeleteU (item) {
			if (item) {
				this.$confirm(`将永久删除成员 <span class="text-danger">${item.username}</span> ，是否继续？`, '删除成员', {
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(() => {
					delUserApi({ uids: [item.uid] }).then(res => {
						if (!res.errno) {
							// 操作成功处理
							this.$message.success('删除成功！')
							this.fetchData()
						} else {
							this.$message.error(res.message)
						}
					})
				})
			} else {
				this.$confirm(`将永久删除选中的 <span class="text-danger">${this.multiSelection.length}</span> 成员，是否继续？`, '删除成员', {
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(() => {
					const temp = this.multiSelection.map(item => item.uid)
					delUserApi({ uids: temp }).then(res => {
						if (!res.errno) {
							// 操作成功处理
							this.$message.success('删除成功！')
							this.fetchData()
						} else {
							this.$message.error(res.message)
						}
					})
				})
			}
		},

		resetP (item) {
			this.$prompt(`请重新设定 <span class="text-danger">${item.username}</span> 的密码`, '重置密码', {
				closeOnClickModal: false,
				inputErrorMessage: '密码不能为空',
				dangerouslyUseHTMLString: true,
				inputValue: '',
				inputPlaceholder: '请填写新密码'
			})
				.then(({ value }) => {
					item.password = value
					editUserApi(item).then(res => {
						if (!res.errno) {
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					})
				})
				.catch(() => {
					// 取消
				})
		},

		editorUser (uid) {
			this.uid = uid
			this.showEditor = true
		}
	}
}
</script>

<style lang="scss" scoped>
.sys-user {
	position: relative;
}
</style>
